jQuery(document).ready(function($) {
	jQuery('.has_hidden p a').on('click', function(e){
		e.preventDefault();
		jQuery('.has_hidden em').slideToggle();
		jQuery('.has_hidden em').toggleClass('show');
		if(jQuery('.has_hidden p a').hasClass('active')){
			jQuery('.has_hidden p a').text('Read Full Story');
			jQuery('.has_hidden p a').removeClass('active');
		}
		else{
			jQuery('.has_hidden p a').text('Hide Full Story');
			jQuery('.has_hidden p a').addClass('active');
		}
	});

    jQuery('.cru-2-col').each(function(){
        parentHeight = jQuery(this).height();
        jQuery(this).children('.image-column').height(parentHeight);
    });

    jQuery('a.scroll_to').on('click', function(e){
		e.preventDefault();
		jQuery('a.scroll_to').each(function(){
			jQuery(this).removeClass('active');
		});
		jQuery(this).addClass('active');
		var targ = jQuery(this).attr('href');
		if(targ == "#our-story" && jQuery(window).width() <= 782){
			targ = "#terrior_mobile";
		}
		if(jQuery(window).width() > 900){
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
		else{
			jQuery('html, body').animate({
				scrollTop: jQuery(targ).offset().top - 50
			}, 1000);
		}
	});

	// Keep sticky page navigation (.page_nav_container) directly under the fixed header
	var $fixedHeader = jQuery('.header-container[data-sticky="true"]');
	function headerBottom() {
		return $fixedHeader.length ? Math.max(0, Math.round($fixedHeader[0].getBoundingClientRect().bottom)) : 0;
	}
	function setStickyTop() {
		document.documentElement.style.setProperty('--cru-sticky-top', headerBottom() + 'px');
	}
	setStickyTop();
	jQuery(window).on('resize scroll', setStickyTop);

	// Bring the current page's link into view in the sideways-scrolling page navigation
	jQuery('.our_story_navigations ul').each(function(){
		var list = this;
		var active = list.querySelector('a.active');
		if (!active || list.scrollWidth <= list.clientWidth) return;
		var linkBox = active.getBoundingClientRect();
		var listBox = list.getBoundingClientRect();
		list.scrollLeft += (linkBox.left - listBox.left) - (list.clientWidth - linkBox.width) / 2;
	});

	jQuery('.wine_navigations a').on('click', function(e){
		var targ = jQuery(this).attr('href');
		if (!targ || targ.charAt(0) !== '#' || !jQuery(targ).length) return;
		e.preventDefault();
		// Leave room for the fixed header and the sticky page navigation
		var offset = headerBottom() + (jQuery('.page_nav_container').outerHeight() || 0) + 20;
		jQuery('html, body').animate({
			scrollTop: jQuery(targ).offset().top - offset
		}, 700);
	});

	jQuery('.image-column .slider').slick({
	    infinite: true,
	    dots: true,
	    speed: 500,
	    fade: true,
	    cssEase: 'linear',
	    autoplay: true,
  		autoplaySpeed: 5000,
  		prevArrow:"<i class='fa-solid fa-chevron-left'></i>",
      	nextArrow:"<i class='fa-solid fa-chevron-right'></i>"
	});

	var product_item_height = 0;
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		if(jQuery(this).height() > product_item_height){
			product_item_height = jQuery(this).height();
		}
	});
	jQuery('.cru-product-collection .cru-product-item').each(function(){
		jQuery(this).height(product_item_height);
	});

	if(jQuery(window).width() <= 781){
		jQuery('.layout-grid .cru-product-slider').slick({
			infinite: true,
			dots: true,
			speed: 500,
			fade: true,
			cssEase: 'linear',
			autoplay: false
		});
	}

	jQuery('a.open_submenu').on('click', function(e){
		e.preventDefault();
		console.log('test');
		jQuery(this).siblings('ul.sub-menu').html();
		if(jQuery(this).hasClass('active')){
			jQuery(this).parent().removeClass('active');
			jQuery(this).removeClass('active');
		}
		else{
			jQuery(this).parent().addClass('active');
			jQuery(this).addClass('active');
		}
	});

	jQuery('.cta-block a.btn').on('click', function(e){
		e.preventDefault();
		if(!jQuery(this).siblings('.cta-overlay').hasClass('active')){
			jQuery('.cta-overlay.active').each(function(){
				jQuery(this).removeClass('active');
				jQuery(this).slideToggle();
			});
			jQuery(this).siblings('.cta-overlay').addClass('active');
			jQuery(this).siblings('.cta-overlay').slideToggle();
		}
		else{
			jQuery(this).siblings('.cta-overlay').removeClass('active');
			jQuery(this).siblings('.cta-overlay').slideToggle();
		}
	});

	jQuery('a.accordion_link').on('click', function(e){
		e.preventDefault();
		var targ = jQuery(this).attr('targets');
		jQuery('#'+targ).slideToggle();
	});
});

/* Visit jump nav: the link for the section currently in view takes the active (burgundy) state.
   Navs marked no_spy (Contact) carry no active state in the design */
jQuery(function () {
	var links = jQuery('.wine_navigations:not(.no_spy) a[href^="#"]').filter(function () {
		return jQuery(this.getAttribute('href')).length;
	});
	if (!links.length) return;
	var nav = document.querySelector('.page_nav_container');
	function update() {
		var line = (nav ? nav.getBoundingClientRect().bottom : 0) + 24;
		var current = links.first();
		links.each(function () {
			var target = document.querySelector(this.getAttribute('href'));
			if (target && target.getBoundingClientRect().top <= line) current = jQuery(this);
		});
		if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) current = links.last();
		links.removeClass('active');
		current.addClass('active');
	}
	var ticking = false;
	window.addEventListener('scroll', function () {
		if (ticking) return;
		ticking = true;
		window.requestAnimationFrame(function () { ticking = false; update(); });
	}, { passive: true });
	window.addEventListener('resize', update);
	update();
});
